import * as React from "react";
const SvgDownload = props => <svg xmlns="http://www.w3.org/2000/svg" width={15} height={17} {...props}><path fill="#47CFCB" d="M15 6h-4.286V0H4.286v6H0l7.5 7L15 6zM0 15v2h15v-2H0z" /></svg>;
export default SvgDownload;